import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Planning } from '../../../classes/planning.class';
import { CodaltComponent } from '../../../codalt.component';
import { FieldType } from '../../../services/entities/entity-type.class';
import { EntityFormField } from '../../../services/entity-type.service';
import { PlanningService } from '../../../services/planning/planning.service';

interface HiringSelectItem {
    id: null;
    name: string;
    companyName?: string;
    hiringId?: number;
}

@Component({
    selector: 'app-add-hiring-to-planning-dialog',
    standalone: false,
    templateUrl: './add-hiring-to-planning-dialog.component.html',
    styleUrl: './add-hiring-to-planning-dialog.component.scss',
})
export class AddHiringToPlanningDialogComponent extends CodaltComponent implements OnInit {
    fcEmployee = new FormControl();
    fcName = new FormControl();
    hiring_id: EntityFormField = {
        name: 'Leverancier',
        type: FieldType.Hiring,
        fc: new FormControl(),
        dataFilter: ['hiringStaff'],
    };
    filteredEmployees: HiringSelectItem[];

    addHiringTagFn = (term: string) => ({ id: null, name: term, isHiring: true as const });

    searchFn = (term: string, item: HiringSelectItem) => {
        const t = term.toLowerCase();
        return !!(item.name?.toLowerCase().includes(t) || item.companyName?.toLowerCase().includes(t));
    };

    constructor(
        public dialogRef: MatDialogRef<AddHiringToPlanningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Planning,
        private planningService: PlanningService
    ) {
        super();
    }

    ngOnInit(): void {
        const seenHiring = new Map<string, HiringSelectItem>();
        this.planningService
            .getCurrentPlannings()
            .flatMap(p => p.planning_has ?? [])
            .filter(phe => phe.entitytype_key === 'hiringStaff' && phe.name)
            .forEach(phe => {
                const key = `${phe.name}|${phe.hiring_id ?? ''}`;
                if (!seenHiring.has(key)) {
                    seenHiring.set(key, {
                        id: null,
                        name: phe.name,
                        companyName: phe.hiring?.name,
                        hiringId: phe.hiring_id,
                    });
                }
            });
        this.filteredEmployees = Array.from(seenHiring.values());
        const currentHiring = this.data.planning_has.find(ph => ph.entitytype_key === 'hiringStaff');
        if (currentHiring) {
            this.hiring_id.fc.setValue(currentHiring.hiring_id);
        }
    }

    onEmployeeChange(item: HiringSelectItem) {
        if (!item) {
            return;
        }
        this.fcName.setValue(item.name);
        if (item.hiringId) {
            this.hiring_id.fc.setValue(item.hiringId);
        }
    }

    add() {
        this.dialogRef.close({
            name: this.fcName.value,
            hiring_id: this.hiring_id.fc.value,
        });
    }
}
